<template>
    <div class="row">
        <div class="col-md-6">
            <div class="admin-form theme-primary tab-pane mw700 active" role="tabpanel">
                <div class="panel panel-primary heading-border">
                    <div class="panel-heading">
                        <span class="panel-title">
                            <i class="fa fa-pencil-square"></i>
                            Выемка из кассы
                        </span>
                    </div>
                    <form @submit.prevent="submit" :disable="outflow.isSubmitting === true">
                        <div class="panel-body p25">

                            <div class="section row">
                                <div class="col-md-6">
                                    <label for="payment_type" class="field-label">Тип платежа</label>
                                    <label class="field select">
                                        <select id="payment_type" name="payment_type" v-model="$v.outflow.type.$model">
                                            <option v-for="(type, index) in this.data.types" v-bind:key="index" :value="type.id">
                                                {{type.name}}
                                            </option>
                                        </select>
                                        <i class="arrow double"/>
                                    </label>
                                    <div v-if="$v.outflow.type.$error === true || outflow.errors.type" class="error">
                                        {{ this.outflow.errors.type ? this.outflow.errors.type.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                                <div class="col-md-6" v-if="outflow.type === 2 || outflow.type === 11 || outflow.type === 1">
                                    <label for="payment_employees_all" class="field-label">Сотрудник</label>
                                    <label class="field select">
                                        <select id="payment_employees_all" name="payment_employees_all" v-model="$v.outflow.employee.$model">
                                            <optgroup label="Административный персонал">
                                                <option v-for="user in this.data.users" v-bind:key="user.id" :value="'user-' + user.id">
                                                    {{user.fullName}}
                                                </option>
                                            </optgroup>
                                            <optgroup label="Преподаватели">
                                                <option v-for="trainer in this.data.trainers" v-bind:key="trainer.id" :value="trainer.id">
                                                    {{trainer.fullName}}
                                                </option>
                                            </optgroup>
                                        </select>
                                        <i class="arrow double"/>
                                    </label>
                                    <div v-if="$v.outflow.employee.$error === true || outflow.errors.employee" class="error">
                                        {{ this.outflow.errors.employee ? this.outflow.errors.employee.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                                <div class="col-md-6" v-else>
                                    <label for="payment_employees" class="field-label">Сотрудник</label>
                                    <label class="field select">
                                        <select id="payment_employees" name="payment_employees" v-model="$v.outflow.employee.$model">
                                            <option v-for="user in this.data.users" v-bind:key="user.id" :value="user.id">
                                                {{user.fullName}}
                                            </option>
                                        </select>
                                        <i class="arrow double"/>
                                    </label>
                                    <div v-if="$v.outflow.employee.$error === true || outflow.errors.employee" class="error">
                                        {{ this.outflow.errors.employee ? this.outflow.errors.employee.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                            </div>

                            <div class="section row">
                                <div class="col-md-6">
                                    <label for="price" class="field-label">Сумма</label>
                                    <label for="price" class="field prepend-icon">
                                        <input type="text" name="price" id="price" class="gui-input" v-model="$v.outflow.sum.$model">
                                        <label for="price" class="field-icon">
                                            <i class="glyphicon glyphicon-rub"/>
                                        </label>
                                    </label>
                                    <div v-if="$v.outflow.sum.$error === true || outflow.errors.sum" class="error">
                                        {{ this.outflow.errors.sum ? this.outflow.errors.sum.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <label class="field-label">Записать на дату</label>
                                    <label class="field prepend-icon">
                                        <input v-model="$v.outflow.date.$model" type="date" class="gui-input">
                                        <label class="field-icon">
                                            <i class="fa  fa-calendar"></i>
                                        </label>
                                    </label>
                                    <div v-if="$v.outflow.date.$error === true || outflow.errors.date" class="error">
                                        {{ this.outflow.errors.date ? this.outflow.errors.date.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                            </div>

                            <div class="section row mb25">
                                <div class="col-md-12">
                                    <label class="field-label">Комментарий</label>
                                    <label class="field prepend-icon">
                                        <textarea class="gui-textarea" v-model="$v.outflow.comment.$model"></textarea>
                                        <label class="field-icon">
                                            <i class="fa fa-edit"></i>
                                        </label>
                                    </label>
                                </div>
                            </div>

                        </div>
                        <div class="panel-footer">
                            <button type="submit" class="button btn-primary" :disabled="outflow.isSubmitting">
                                Выдать
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import User from "../../models/v2/User";
    import Trainer from "../../models/v2/Trainer";
    import { required } from 'vuelidate/lib/validators';
    import { validationMixin } from 'vuelidate';
    import Cashflow from "../../models/Cashflow";
    import CashflowApi from "../../classes/api/Cashflow";
    import ValidationError from "../../classes/ValidationError";
    import moment from 'moment';

    export default {
        mixins: [validationMixin],
        async beforeRouteEnter(to, from, next) {

            try {
                const users = await User.getList({}, 1, 'last_name,name', -1);
                const trainers = await Trainer.getList({}, 1, 'last_name,first_name', -1);
                next(async component => {
                    component.data.users = users.data;
                    component.data.trainers = trainers.data;
                });
            } catch (error) {
                next({
                    name: 'error',
                    path: to.fullPath,
                    params: {
                        code: error.response.status,
                        codeText: error.response.statusText,
                        message: error.response.data.message,
                        trace: error.response.data.type,
                    },
                })
            }
        },
        data() {
            return {
                data: {
                    users: [],
                    trainers: [],
                    types: Cashflow.getTypesLess().filter(type => {
                        if (type.id === Cashflow.TYPE_LESS_ADV || type.id === Cashflow.TYPE_LESS_COLLECTION) {
                            return false;
                        }
                        return true;
                    }),
                },
                outflow: {
                    type: Cashflow.TYPE_LESS_SALARY,
                    employee: 0,
                    sum: '',
                    date: '',
                    comment: '',

                    isSubmitting: false,
                    errors: {},
                },
            };
        },
        validations: {
            outflow: {
                type: {required},
                employee: {required},
                sum: {required},
                date: {required},
                comment: {},
            },
        },
        methods: {
            async submit() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return false;
                }

                this.outflow.isSubmitting = true;
                this.outflow.errors = {};

                try {
                    await CashflowApi.add({
                        type_id: this.outflow.type,
                        people_id: this.outflow.employee,
                        flow: Cashflow.FLOW_LESS,
                        payment_type: Cashflow.PAYMENT_TYPE_CASH,
                        sum: this.outflow.sum,
                        comment: this.outflow.comment,
                        date: moment(this.outflow.date).unix(),
                    }).then(({data}) => {
                        if (data.success === false) {
                            throw new ValidationError(data.errors);
                        }
                        return true;
                    });

                    this.$notify({
                        text: 'Сохранено',
                    });
                } catch (error) {
                    this.outflow.errors = error.errors;
                }

                this.outflow.isSubmitting = false;
            },
        },
        metaInfo() {
            return {
                title: 'Выемка из кассы',
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>
